"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const useStyles = (0, react_jss_1.createUseStyles)({
    root: {
        height: 0,
        bottom: 0,
        width: "100%",
        position: "absolute",
        transformOrigin: "25px calc(100% - 25px)",
        border: "2px solid #eee",
        zIndex: 1,
    },
});
const WinOutline = ({ rotation, length, origin, }) => {
    const classes = useStyles();
    const aspectRatio = 1 +
        (length - 1) * (Math.abs(Math.sin(rotation)) + Math.abs(Math.cos(rotation)));
    return (react_1.default.createElement("div", { className: classes.root, style: {
            transform: `translate(${origin.x * 50}px, -${50 * origin.y}px) rotate(${rotation}rad)`,
            borderRadius: `100% / ${100 / aspectRatio}%`,
            paddingBottom: `calc(${100 * aspectRatio}% - 4px)`,
        } }));
};
exports.default = WinOutline;
